import {
    getIsRegistered,
    getRegistrationPending,
} from '@/redux/modules/catalog/registration/catalogRegistration.selectors';
import {
    getIsTimedPlusItemBiddingClosed,
    getItemModelIsPaused,
    hasItemSummaryStarted,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { useAppSelector } from '@/redux/hooks';
import OpenForBidding from '@/components/ItemBidding/components/OpenForBidding/OpenForBidding';
import TimedPlusItemBiddingLotWithdrawn from '@/components/ItemBidding/components/TimedPlus/components/LotWithdrawn/TimedPlusItemBiddingLotWithdrawn';
import TimedPlusItemBiddingNotRegistered from './components/NotRegistered/TimedPlusItemBiddingNotRegistered';
import TimedPlusItemBiddingNotStarted from './components/NotStarted/TimedPlusItemBiddingNotStarted';
import TimedPlusItemBiddingPendingRegistration from '@/components/ItemBidding/components/TimedPlus/components/PendingRegistration/TimedPlusItemBiddingPendingRegistration';

export type TimedPlusBiddingInfoProps = {
    catalogId: number;
    itemId: number;
};

const TimedPlusBiddingInfo = ({ catalogId, itemId }: TimedPlusBiddingInfoProps) => {
    const isRegistered = useAppSelector((state) => getIsRegistered(state, catalogId));
    const isRegistrationPending = useAppSelector((state) => getRegistrationPending(state, catalogId));
    const hasStarted = useAppSelector((state) => hasItemSummaryStarted(state, itemId));
    const isClosed = useAppSelector((state) => getIsTimedPlusItemBiddingClosed(state, itemId));
    const isPaused = useAppSelector((state) => getItemModelIsPaused(state, itemId));

    if (isPaused) {
        return <TimedPlusItemBiddingLotWithdrawn itemId={itemId} />;
    }
    if (isRegistrationPending && hasStarted) {
        return <TimedPlusItemBiddingPendingRegistration itemId={itemId} />;
    }
    if (!hasStarted && !isClosed) {
        return (
            <TimedPlusItemBiddingNotStarted
                catalogId={catalogId}
                itemId={itemId}
            />
        );
    }
    if (!isRegistered && !isClosed) {
        return (
            <TimedPlusItemBiddingNotRegistered
                catalogId={catalogId}
                isLive={hasStarted}
                itemId={itemId}
            />
        );
    }

    return <OpenForBidding itemId={itemId} />;
};

export default TimedPlusBiddingInfo;
